import {Injectable} from '@angular/core';
import {Catalogs} from '../constants/catalogs';
import {CatalogObj} from '../models/catalog-obj';
import {CatalogsFilters} from '../constants/catalogs-filters';

@Injectable({
  providedIn: 'root'
})
export class CatalogsMapService {

  catalogsByType: CatalogObj[] = [
    {
      catalog: Catalogs.Organizations, name: 'Організації', routerLink: 'organizations', filters: [],
      displayData: false, editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/PXQQbgE3ErkSf1A'
    },
    {
      catalog: Catalogs.Fields, name: 'Поля', routerLink: 'fields',  displayData: false,
      filters: [CatalogsFilters.Search, CatalogsFilters.Region, CatalogsFilters.Organization],
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/BbNl5Vwa5desDTn'
    },
    {
      catalog: Catalogs.Crops, name: 'Культури', routerLink: 'crops', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/rzPFo04UpPfaWi7'
    },
    {
      catalog: Catalogs.CropRotation, name: 'Сівозміна', routerLink: 'crop-rotation', displayData: false,
      filters: [CatalogsFilters.Search, CatalogsFilters.Year, CatalogsFilters.Organization, CatalogsFilters.Crop],
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/aOJEJ8lG02PoalL'
    },
    {
      catalog: Catalogs.WorkHistory, name: 'Історія робіт', routerLink: 'work-history', displayData: false,
      filters: [CatalogsFilters.Search, CatalogsFilters.Year, CatalogsFilters.Organization, CatalogsFilters.Crop],
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/8FuMJ1fZbTSTo2C'
    },
    {
      catalog: Catalogs.VehicleModels, name: 'Моделі техніки', routerLink: 'auto-models', filters: [],
      editable: false, creatable: false, displayData: false, templateUrl: 'https://files.agrichain.com.ua/s/5mivF5voihM6dJT'
    },
    {
      catalog: Catalogs.AutoTypes, name: 'Типи техніки', routerLink: 'auto-types', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/TQ8Imz5ZBaMB9Q2'
    },
    {
      catalog: Catalogs.SoilOperationTypes, name: 'Типи техоперацій', routerLink: 'soil-operation-types', filters: [],
      editable: false, creatable: false, displayData: false, templateUrl: 'https://files.agrichain.com.ua/s/ZZxTlsLJVbLri2t'
    },
    {
      catalog: Catalogs.TechOperations, name: 'Техоперації', routerLink: 'tech-operations', filters: [],
      editable: false, creatable: false, displayData: false, templateUrl: 'https://files.agrichain.com.ua/s/1qXaVAgrvHu3NLW'
    },
    {
      catalog: Catalogs.Unit, name: 'Одиниці виміру', routerLink: 'units', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/oEBfIxK2LMmwYZh'
    },
    {
      catalog: Catalogs.ConsumableTypes, name: 'Типи ТМЦ', routerLink: 'consumable-types', filters: [],
      editable: false, creatable: false, displayData: false, templateUrl: 'https://files.agrichain.com.ua/s/FRv68ovzrDkknvO'
    },
    {
      catalog: Catalogs.Consumables, name: 'ТМЦ', routerLink: 'consumables', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/vVO4gLXVbYx9D0E'
    },
    {
      catalog: Catalogs.Diseases, name: 'Хвороби', routerLink: 'diseases', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/VkkiZisLalhMvzH'
    },
    {
      catalog: Catalogs.Vermins, name: 'Шкідники', routerLink: 'vermins', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/UsQhLn4799JOW7T'
    },
    {
      catalog: Catalogs.Weed, name: 'Бур\'яни', routerLink: 'weed', filters: [], displayData: false,
      editable: false, creatable: false, templateUrl: 'https://files.agrichain.com.ua/s/mKd9mQxJLx7mki2'
    },
    {
      catalog: Catalogs.Soils, name: 'Ґрунти', routerLink: 'soils', filters: [],
      displayData: false, editable: false, creatable: false
    },
    {
      catalog: Catalogs.ConsumableRatio, name: 'Маса насіння', routerLink: 'consumableRatio',
      filters: [CatalogsFilters.Search], displayData: true, editable: true, creatable: true, createTitle: 'Нова маса',
      reloadAfterCreate: true, reloadAfterUpdate: true, searchable: true,
    },
    {
      catalog: Catalogs.FieldConsumable, name: 'Гібриди для полів', routerLink: 'fieldConsumable', filters: [CatalogsFilters.Search],
      displayData: true, editable: true, creatable: true, createTitle: 'Новий гібрид',
      reloadAfterCreate: true, reloadAfterUpdate: true, searchable: true,
    },
    {
      catalog: Catalogs.SoilHumidity, name: 'Вологість ґрунту', routerLink: 'soilHumidity', filters: [],
      displayData: false, editable: false, creatable: false
    },
    {
      catalog: Catalogs.CropDevelopmentPhases, name: 'Фази розвитку рослин', routerLink: 'cropDevelopmentPhases', filters: [],
      displayData: true, editable: false, creatable: true, useDialog: true
    },
    {
      catalog: Catalogs.CropDevelopmentIndicators, name: 'Показники розвитку рослин', routerLink: 'cropDevelopmentIndicators', filters: [],
      displayData: true, editable: false, creatable: true, useDialog: true
    },
    {
      catalog: Catalogs.CartogramYield, name: 'Картограма врожайності', routerLink: 'cartogram-yield', filters: [],
      displayData: false, editable: false, creatable: false, standaloneLayout: true
    },
    {
      catalog: Catalogs.FieldLayers, name: 'Шари полів', routerLink: 'field-layers', filters: [],
      displayData: false, editable: false, creatable: false, standaloneLayout: true
    },
    {
      catalog: Catalogs.ReportSettings, name: 'Налаштування звітів', routerLink: 'report-settings', filters: [],
      displayData: false, editable: false, creatable: false, standaloneLayout: true
    },
  ];

  customCatalogs: CatalogObj[] = [
    {
      catalog: Catalogs.Threats, name: 'Загрози', routerLink: 'threats', filters: [],
      displayData: false, editable: false, creatable: false
    }
  ];

  getCatalogByProperty(value: unknown, property: keyof CatalogObj): CatalogObj {
    // Спочатку шукаємо в системних каталогах
    let catalog = this.catalogsByType.find(item => item[property] === value);
    
    // Якщо не знайшли, шукаємо в користувацьких каталогах
    if (!catalog) {
      catalog = this.customCatalogs.find(item => item[property] === value);
    }
    
    return catalog;
  }
}
